
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
	name: 'LoaderDisplay',
	components: {},
})
export default class LoaderDisplay extends Vue {
	@Prop({ default: false }) small!: boolean;
	@Prop({ default: false }) light!: boolean;
}
